var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wave-dot",class:{ 'is-large': _vm.isLarge }},[_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"}),_c('span',{staticClass:"dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }